// extracted by mini-css-extract-plugin
module.exports = {"SOC-detail":"SOC_SOC-detail__57ZMH"};